import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background text-primary flex items-center justify-center px-6 relative">
      <div className="noise-overlay" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 w-full max-w-lg bg-white border border-border rounded-sm p-10 sm:p-14"
        data-testid="payment-cancel-page"
      >
        <Link to="/" className="font-serif text-2xl">CakesbyaKid</Link>
        <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center my-6">
          <XCircle className="text-accent" size={26} />
        </div>
        <h1 className="font-serif text-3xl sm:text-4xl">Checkout canceled</h1>
        <p className="text-secondary mt-4 leading-relaxed">
          No deposit was taken and your week is <span className="text-primary font-medium">not reserved</span> yet.
          Whenever you're ready, you can pick your week and pay the $25 deposit to lock it in.
        </p>
        <Button asChild className="btn-sweep bg-primary text-primary-foreground hover:text-primary-foreground rounded-sm h-12 px-8 mt-8">
          <Link to="/#order" data-testid="resume-order-button">Return to order form</Link>
        </Button>
      </motion.div>
    </div>
  );
}
